import { Helmet } from 'react-helmet-async';

const SEOHead = ({ 
  title, 
  description, 
  keywords = '',
  author = 'VaporDesigns Team',
  type = 'website',
  image = 'https://vapordesigns.netlify.app/images/LogoDefinitivo.png',
  url = 'https://vapordesigns.netlify.app',
  publishedDate,
  modifiedDate,
  tags = [],
  category,
  readTime,
  lang = 'es-ES',
  structuredData
}) => {
  // Construir título completo con marca
  const fullTitle = title.includes('VaporDesigns') ? title : `${title} | VaporDesigns`;
  
  // URL canónica
  const canonicalUrl = url.startsWith('http') ? url : `https://vapordesigns.netlify.app${url}`;
  
  return (
    <Helmet>
      {/* Título y descripción básicos */}
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      
      {/* Keywords si se proporcionan */}
      {keywords && <meta name="keywords" content={keywords} />}
      
      {/* Autor */}
      <meta name="author" content={author} />
      
      {/* URL canónica */}
      <link rel="canonical" href={canonicalUrl} />
      
      {/* Open Graph / Facebook */}
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content={type} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:image" content={image} />
      <meta property="og:image:alt" content={title} />
      <meta property="og:site_name" content="VaporDesigns" />
      <meta property="og:locale" content="es_ES" />
      
      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      <meta name="twitter:image:alt" content={title} />
      <meta name="twitter:site" content="@vapordesigns" />
      <meta name="twitter:creator" content="@vapordesigns" />
      
      {/* Fechas para artículos */}
      {publishedDate && <meta property="article:published_time" content={publishedDate} />}
      {modifiedDate && <meta property="article:modified_time" content={modifiedDate} />}
      {author && <meta property="article:author" content={author} />}
      {category && <meta property="article:section" content={category} />}
      
      {/* Tags para artículos */}
      {tags.length > 0 && tags.map(tag => (
        <meta key={tag} property="article:tag" content={tag} />
      ))}
      
      {/* Idioma */}
      <html lang={lang} />
      
      {/* Robots */}
      <meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />
      
      {/* Schema.org structured data */}
      {structuredData && (
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      )}
    </Helmet>
  );
};

export default SEOHead;